module.exports = __webpack_public_path__ + "img/app-dne-download-android.02f776d6.svg";